import { AstUtils, type MaybePromise, type ValidationAcceptor } from "langium";
import { RegExpParser } from "regexpp";
import type { ReferenceType, ReferenceTypeOption, Type } from "../generated/ast.js";
import { BUILTIN_LIBRARY_URI } from "./index.js";

export class IprotoBuiltinValidator {
	private validateStringOptions(node: ReferenceTypeOption, accept: ValidationAcceptor) {
		if (node.target.$refText === "pattern") {
			try {
				new RegExpParser({}).parsePattern(node.value?.value as string);
			} catch (e) {
				// @ts-ignore
				accept("error", `${e?.message}`, { node });
			}
		}
	}

	validateReferenceTypeOption(node: ReferenceTypeOption, accept: ValidationAcceptor): MaybePromise<void> {
		const target = node.target.ref;

		if (target) {
			const documentUri = AstUtils.getDocument(target).uri.toString();

			if (documentUri === BUILTIN_LIBRARY_URI) {
				switch (target.$container.name) {
					case "String": {
						this.validateStringOptions(node, accept);
						break;
					}
				}
			}
		}
	}

	private validateReferenceUnion(node: ReferenceType, accept: ValidationAcceptor) {
		for (const ref of node.arguments) {
			const target = ref.target.ref;

			if (target && target.$type !== "Struct") {
				return accept("error", "Union only accepts struct types as parameters.", { node: ref });
			}
		}

		const argumentsSet = new Set<Type>();

		for (const ref of node.arguments) {
			const target = ref.target.ref;

			if (target) {
				if (argumentsSet.has(target)) {
					return accept(
						"error",
						`Union cannot have duplicate parameters, but '${target.name}' appears more than once.`,
						{ node: ref },
					);
				}

				argumentsSet.add(target);
			}
		}
	}

	validateReferenceType(node: ReferenceType, accept: ValidationAcceptor) {
		const target = node.target.ref;

		if (target) {
			const documentUri = AstUtils.getDocument(target).uri.toString();

			if (documentUri === BUILTIN_LIBRARY_URI) {
				if (target.$type === "Scalar" && target.name === "Union") {
					this.validateReferenceUnion(node, accept);
				}
			}
		}
	}
}
